import * as actionTypes from "../actions/actionTypes";
import {defaultLanguage} from "languages/languages"

const initialState = {
  lang: defaultLanguage,
};

const languageReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_LANGUAGE:
      return { ...state, lang: payload };

    default:
      return state;
  }
};

export default languageReducer;
